export default __webpack_public_path__ + "static/media/debt_thin.ec1ed039.svg";